import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UnsavedChangesService } from '@shared/services';

@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './unsaved-changes.component.html',
  styleUrls: ['./unsaved-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UnsavedChangesComponent {
  constructor(public unsavedChangesService: UnsavedChangesService) {}
}
